import React from "react";
import "../styles/ActivitiesCalendar.css";
import { FaFilePdf } from "react-icons/fa";
import { Worker, Viewer } from "@react-pdf-viewer/core";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";

// PDF file
import Events_Calendar_2025 from "../Assets/Pdfs/Events_Calender_2026.pdf";

export default function EventsCalendar() {
    const defaultLayoutPluginInstance = defaultLayoutPlugin();

    return (
        <div className="events-calendar-page">
            <section className="events-calendar-section pdf-section">
                <h2>
                    <FaFilePdf className="pdf-icon" /> Activities Calendar 2026
                </h2>

                {/* PDF Viewer */}
                <div className="pdf-viewer">
                    <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
                        <Viewer
                            fileUrl={Events_Calendar_2025}
                            plugins={[defaultLayoutPluginInstance]}
                        />
                    </Worker>
                </div>

                {/* Download Link */}
                <p className="pdf-download">
                    <a
                        href={Events_Calendar_2025}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Download Events Calendar 2026
                    </a>
                </p>
            </section>

            <footer className="events-calendar-footer">
                <p>Stay updated with all academic and cultural events throughout the year.</p>
            </footer>
        </div>
    );
}
